Vendd.Scripts.load(function () {

    $('.x-control.x-product-review-form[data-control="form"][data-ajax="true"]').each(function (i, form) {

        var onSuccessFn = form.onSuccess;
        form.onSuccess = function (request, response) {
            onSuccessFn(request, response);

            var $productRerviewControl = $('.x-control.x-product-reviews[data-type="reviews"]:first');

            if ($productRerviewControl.length == 0)
                throw new Error('Product rerview control does not exist.');

            $productRerviewControl.find('.critics.form-show-hide').remove();
            $productRerviewControl.find('.already-reviewed-status').show();
           // $productRerviewControl.find('.critics.review-status').show();
        };

        form.submit = function (config) {
            if (form.isLoading())
                return;

            form.showLoader();

            var state = Vendd.Product.Controller.getState();
            var id = state.parentId;

            Vendd.MessageBus.publishAsync(form,
                new Vendd.Product.Messages.Review(config.title, config.description, config.rating, id));
        };

        function successFn (envelope) {
            form.hideLoader();

            var responseData = envelope.message.data;

            if (responseData.Success) responseData.success = responseData.Success;
            if (responseData.Code) responseData.code = responseData.Code;
            if (responseData.data) responseData.data = responseData.Data;
            if (responseData.time) responseData.time = responseData.Time;

            if (!responseData.success && responseData.code == 'GenericError') {
                if (typeof (responseData.Data) == 'string') {
                    try {
                        responseData.Data = jQuery.parseJSON(responseData.Data);
                    } catch (e) {

                    }
                };
            };

            if (responseData.success && typeof (form.onSuccess) === 'function') {

                form.onSuccess(envelope.message.config, responseData);
            } else {
                if (!responseData.success && typeof (form.onFailure) === 'function') {

                    form.onFailure(envelope.message.config, responseData);
                };
            };
        };

        function failureFn (ex) {
            form.hideLoader();

            var response = {
                code: 'GenericError',
                success: false,
                time: 0
            };

            if (ex.responseText) {
                response.data = jQuery.parseJSON(ex.responseText)
            } else {
                response.data = ex;
            };

            if (typeof (form.onFailure) === 'function') {
                form.onFailure(config, response);
            };
        };

        Vendd.MessageBus.subscribe(Vendd.Product.Messages.ReviewSuccess, form, successFn);
        Vendd.MessageBus.subscribe(Vendd.Product.Messages.ReviewFailure, form, failureFn);
    });
});

